import { render, staticRenderFns } from "./AddFocusBuy.vue?vue&type=template&id=1c57b3a2&scoped=true"
import script from "./AddFocusBuy.vue?vue&type=script&lang=js"
export * from "./AddFocusBuy.vue?vue&type=script&lang=js"
import style0 from "./AddFocusBuy.vue?vue&type=style&index=0&id=1c57b3a2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c57b3a2",
  null
  
)

export default component.exports